__webpack_require__.p = "/akshita_portfolio/";